import { api } from "@/api";
import {
  QuickCreateProspectOptions,
  QuickCreateProspectRequest,
  QuickCreateProspectResponse,
} from "@/types/domain";

export const fetchQuickCreateProspectOptions = async (): Promise<QuickCreateProspectOptions> => {
  const res = await api.get<QuickCreateProspectOptions>("/prospect/quickcreate");
  return res.data;
};

export const quickCreateProspect = async (
  dto: QuickCreateProspectRequest
): Promise<QuickCreateProspectResponse> => {
  const res = await api.post<QuickCreateProspectResponse>("/prospect/quickcreate", dto);
  return res.data;
};
